import Vuex from 'vuex'
import Vue from 'vue'
import { Helper } from '@/services/helper/helper'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    pageReady: false,
    pageVisible: false,
    channelsRendered: false,
    selectedAd: '',
    adData: {},
    adServiceParams: {},
    agent: {},
    contentData: {
      channels: {},
      adLayout: 1
    },
    request: {}
  },
  mutations: {
    setPageReady (state, payload) {
      state.pageReady = payload
    },
    setPageVisible (state, payload) {
      state.pageVisible = payload

      // Used within piNctTracking
      Helper.fireEvent('pageVisible')
    },
    setChannelsRendered (state, payload) {
      state.channelsRendered = payload
    },
    setSelectedAd (state, payload) {
      state.selectedAd = payload
    },
    setContentData (state, payload) {
      state.contentData = { ...state.contentData, ...payload }
    },
    setAdData (state, payload) {
      state.adData = payload

      // Used within piNctTracking
      !window.adData && (window.adData = {})
      window.adData.type = payload.type
      window.adData.variant = payload.variant
    },
    setAdServiceParams (state, payload) {
      state.adServiceParams = payload
    },
    setAgent (state, payload) {
      state.agent = payload
    },
    setChannels (state, payload) {
      state.contentData.channels = payload
    },
    setAdLayout (state, payload) {
      state.contentData.adLayout = payload
    },
    setRequestData (state, payload) {
      state.request = payload
    }
  },
  getters: {
    pageReady: (state) => state.pageReady,
    pageVisible: (state) => state.pageVisible,
    channelsRendered: (state) => state.channelsRendered,
    selectedAd: (state) => state.selectedAd,
    contentData: (state) => state.contentData,
    adData: (state) => state.adData,
    adServiceParams: (state) => state.adServiceParams,
    agent: (state) => state.agent
  }
})
